/* Wholly Balls! Bundle Builder — runtime
   Reads config from <script id="wb-bundle-config" type="application/json"> embedded by the section.
   Multi-line cart add: each selected flavor variant becomes its own /cart/add.js line item,
   with the chosen Bundle Subscribe & Save selling_plan attached when subscribe mode is on.
*/
(function(){
  const root = document.getElementById('wb-bundle');
  if (!root) return;

  const configEl = document.getElementById('wb-bundle-config');
  if (!configEl) { console.error('[wb-bundle] config script not found'); return; }
  const config = JSON.parse(configEl.textContent);

  const state = {
    size: 12,
    mode: 'subscribe',
    freq: 4,
    flavors: {}, // { handle: qty }
  };

  const $  = sel => root.querySelector(sel);
  const $$ = sel => root.querySelectorAll(sel);

  function totalQty() {
    return Object.values(state.flavors).reduce((a,b) => a+b, 0);
  }

  function getPlan() {
    const key = `${state.size}_${state.freq}`;
    return config.plans[key];
  }

  function fmtMoney(amount) {
    return '$' + amount.toFixed(2);
  }

  function render() {
    const p = config.pricing[state.size];

    // Size buttons
    $$('.wb-size').forEach(el => {
      el.classList.toggle('is-selected', parseInt(el.dataset.size) === state.size);
    });
    // Mode buttons
    $$('.wb-mode').forEach(el => {
      el.classList.toggle('is-selected', el.dataset.mode === state.mode);
    });
    // Mode prices
    $('[data-onetime-price]').textContent = fmtMoney(p.onetime);
    $('[data-sub-price]').textContent = fmtMoney(p.subscribe);
    $('[data-onetime-only]').textContent = fmtMoney(p.onetime);
    $('[data-sub-pct]').textContent = `${p.subPct}% off + Free Shipping`;

    // Frequency row visibility
    $('#wb-freq').style.display = state.mode === 'subscribe' ? '' : 'none';
    $$('.wb-freq__pill').forEach(b => {
      b.classList.toggle('is-selected', parseInt(b.dataset.freq) === state.freq);
    });

    // Flavor cards
    $$('.wb-flavor').forEach(card => {
      const h = card.dataset.handle;
      const qty = state.flavors[h] || 0;
      card.classList.toggle('has-qty', qty > 0);
      const qv = card.querySelector('.wb-flavor__qty-val');
      if (qv) qv.textContent = qty;
    });

    // Cart items
    const items = $('#wb-cart-items');
    const filled = Object.entries(state.flavors).filter(([,q]) => q > 0);
    if (filled.length === 0) {
      items.innerHTML = '<div class="wb-cart__empty">Your bundle is empty — start adding flavors!</div>';
    } else {
      items.innerHTML = filled.map(([handle, qty]) => {
        const card = root.querySelector(`.wb-flavor[data-handle="${handle}"]`);
        const name = card.querySelector('.wb-flavor__title').textContent;
        const sku = card.dataset.sku || '';
        const img = card.querySelector('.wb-flavor__img img').src;
        return `<div class="wb-cart__item">
          <img src="${img}" alt="">
          <div class="wb-cart__item-info">
            <div class="wb-cart__item-name">${name}</div>
            ${sku ? `<div class="wb-cart__item-sku">SKU: ${sku}</div>` : ''}
          </div>
          <div class="wb-cart__item-qty">
            <button type="button" data-action="dec" data-handle="${handle}">−</button>
            <span>${qty}</span>
            <button type="button" data-action="inc" data-handle="${handle}">+</button>
          </div>
        </div>`;
      }).join('');
    }

    // Progress
    const total = totalQty();
    const target = state.size;
    const fillPct = Math.min(100, (total / target) * 100);
    $('.wb-cart__progress-fill').style.width = fillPct + '%';
    const status = $('#wb-progress-status');
    if (total === target) {
      status.textContent = `Bundle complete! Ready to ${state.mode === 'subscribe' ? 'subscribe' : 'check out'}.`;
      status.classList.add('is-met');
    } else if (total < target) {
      status.textContent = `Add ${target - total} more bag${target - total > 1 ? 's' : ''} to continue`;
      status.classList.remove('is-met');
    } else {
      status.textContent = `Remove ${total - target} bag${total - target > 1 ? 's' : ''} — bundle is ${target} bags`;
      status.classList.remove('is-met');
    }

    // Total
    $('#wb-cart-onetime').textContent = fmtMoney(p.onetime);
    const perBagEl = $('#wb-cart-perbag');
    const trustEl = $('#wb-cart-trust');
    if (state.mode === 'subscribe') {
      $('#wb-cart-price').textContent = fmtMoney(p.subscribe);
      $('#wb-cart-onetime').style.display = '';
      $('#wb-cart-savings').textContent = `You save ${fmtMoney(p.onetime - p.subscribe)}`;
      $('#wb-cart-savings').style.display = '';
      $('#wb-cart-freq').textContent = `Delivered every ${state.freq} weeks · skip anytime`;
      $('#wb-sub-perks').style.display = '';
      const perk = $('[data-sub-pct-perk]');
      if (perk) perk.textContent = `${p.subPct}% off your bundle`;
      if (perBagEl) perBagEl.textContent = `${fmtMoney(p.subscribe / state.size)} per bag`;
      if (trustEl) trustEl.textContent = 'Skip or cancel anytime · Free shipping every delivery · 30-day promise';
    } else {
      $('#wb-cart-price').textContent = fmtMoney(p.onetime);
      $('#wb-cart-onetime').style.display = 'none';
      $('#wb-cart-savings').style.display = 'none';
      $('#wb-cart-freq').textContent = 'One-time purchase';
      $('#wb-sub-perks').style.display = 'none';
      if (perBagEl) perBagEl.textContent = `${fmtMoney(p.onetime / state.size)} per bag`;
      if (trustEl) trustEl.textContent = '30-day promise · Free shipping $49+ · Made in USA';
    }
    // Manage-subscription note: only relevant in subscribe mode
    const mgr = $('#wb-cart-manage');
    if (mgr) mgr.style.display = state.mode === 'subscribe' ? '' : 'none';

    // CTA
    const cta = $('#wb-cart-cta');
    if (total !== target) {
      cta.disabled = true;
      cta.textContent = total < target ? `Add ${target - total} to Continue` : `Remove ${total - target} to Continue`;
    } else {
      cta.disabled = false;
      cta.textContent = state.mode === 'subscribe'
        ? `Start Subscription — ${fmtMoney(p.subscribe)}/${state.freq}wk`
        : `Add Bundle to Cart — ${fmtMoney(p.onetime)}`;
    }
  }

  function adjust(handle, delta) {
    const cur = state.flavors[handle] || 0;
    let next = cur + delta;
    if (next < 0) next = 0;
    state.flavors[handle] = next;
    if (next === 0) delete state.flavors[handle];
    render();
  }

  function curate(key) {
    const picks = config.curated[key];
    if (!picks) return;
    state.flavors = {};
    let remaining = state.size;
    const perItem = Math.floor(remaining / picks.length);
    picks.forEach(h => { state.flavors[h] = perItem; remaining -= perItem; });
    let i = 0;
    while (remaining > 0) {
      state.flavors[picks[i % picks.length]] = (state.flavors[picks[i % picks.length]] || 0) + 1;
      remaining--;
      i++;
    }
    render();
  }

  async function addToCart() {
    const total = totalQty();
    if (total !== state.size) return;

    // Build line items: one per flavor with qty
    const items = Object.entries(state.flavors).map(([handle, qty]) => {
      const card = root.querySelector(`.wb-flavor[data-handle="${handle}"]`);
      const variantId = parseInt(card.dataset.variantId, 10);
      const item = { id: variantId, quantity: qty };
      if (state.mode === 'subscribe') {
        const plan = getPlan();
        if (plan) item.selling_plan = plan;
      }
      // Tag every line so we can identify them as part of a bundle in Shopify admin / Katana
      item.properties = {
        '_bundle_id': `wb-${state.size}-${state.mode}${state.mode === 'subscribe' ? '-' + state.freq + 'w' : ''}`,
        '_bundle_size': String(state.size),
      };
      return item;
    });

    const cta = $('#wb-cart-cta');
    const origText = cta.textContent;
    cta.disabled = true;
    cta.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || `HTTP ${res.status}`);
      }
      // Success: redirect to checkout for subscribe, or cart for one-time
      window.location.href = state.mode === 'subscribe' ? '/checkout' : '/cart';
    } catch (e) {
      console.error('[wb-bundle] add to cart failed:', e);
      alert('Sorry — could not add the bundle to your cart. ' + e.message);
      cta.disabled = false;
      cta.textContent = origText;
    }
  }

  // Wire up
  $$('.wb-size').forEach(el => el.addEventListener('click', () => {
    state.size = parseInt(el.dataset.size, 10);
    render();
  }));
  $$('.wb-mode').forEach(el => el.addEventListener('click', () => {
    state.mode = el.dataset.mode;
    render();
  }));
  $$('.wb-freq__pill').forEach(el => el.addEventListener('click', () => {
    state.freq = parseInt(el.dataset.freq, 10);
    render();
  }));
  $$('.wb-flavor__add').forEach(b => b.addEventListener('click', () => {
    const card = b.closest('.wb-flavor');
    adjust(card.dataset.handle, 1);
  }));
  root.addEventListener('click', e => {
    if (e.target.matches('.wb-flavor__qty button')) {
      const card = e.target.closest('.wb-flavor');
      adjust(card.dataset.handle, e.target.dataset.action === 'inc' ? 1 : -1);
    } else if (e.target.matches('.wb-cart__item-qty button')) {
      adjust(e.target.dataset.handle, e.target.dataset.action === 'inc' ? 1 : -1);
    }
  });
  $$('.wb-pill').forEach(b => b.addEventListener('click', () => curate(b.dataset.curate)));
  $('#wb-cart-cta').addEventListener('click', addToCart);

  render();
})();
